module.exports = __webpack_public_path__ + "02_freckles.a5c0e106.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer2/02_freckles.png
// module id = pIAd
// module chunks = 0